module.exports = __webpack_public_path__ + "media/images/plan-detail__image-4@2x-c866b31332180f3fb5cdbc00b1594d56.jpg";